var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo, useRef, useState } from 'react';
import { findReports } from './useFindReports';
import { getReport } from './useGetReport';
export function useMultipleReports() {
    const [reportLists, setReportLists] = useState([]);
    const [selectedReports, setSelectedReports] = useState([]);
    const reportListsRef = useRef(reportLists);
    const selectedReportsRef = useRef(selectedReports);
    const load = useCallback((index, params) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const previousParams = (_a = reportListsRef.current[index]) === null || _a === void 0 ? void 0 : _a.params;
        params = Object.assign(Object.assign({}, previousParams), params);
        // set loading for item
        reportListsRef.current = Array.from(reportListsRef.current);
        reportListsRef.current[index] = Object.assign(Object.assign({}, reportListsRef.current[index]), { params, isLoading: true });
        setReportLists(reportListsRef.current);
        const result = yield findReports(params).result;
        reportListsRef.current = Array.from(reportListsRef.current);
        const item = Object.assign(Object.assign({}, result), { params, isLoading: false });
        reportListsRef.current[index] = item;
        setReportLists(reportListsRef.current);
        return item;
    }), []);
    const loadAliases = useCallback((aliasNames, params) => {
        const promises = aliasNames.map((aliasName, index) => {
            return load(index, Object.assign(Object.assign({}, params), { aliasName }));
        });
        return Promise.all(promises);
    }, [load]);
    const clearList = useCallback(() => {
        reportListsRef.current = [];
        setReportLists(reportListsRef.current);
    }, []);
    const getReportList = useCallback((index) => reportLists[index], [reportLists]);
    const getSelectedReport = useCallback((index) => selectedReports[index], [selectedReports]);
    const loadReport = useCallback((index, reportId) => __awaiter(this, void 0, void 0, function* () {
        // set loading for item
        selectedReportsRef.current = Array.from(selectedReportsRef.current);
        selectedReportsRef.current[index] = Object.assign(Object.assign({}, selectedReportsRef.current[index]), { isLoading: true });
        setSelectedReports(selectedReportsRef.current);
        const result = yield getReport(reportId).result;
        selectedReportsRef.current = Array.from(selectedReportsRef.current);
        const item = Object.assign(Object.assign({}, result), { isLoading: false });
        selectedReportsRef.current[index] = item;
        setSelectedReports(selectedReportsRef.current);
        return item;
    }), []);
    // load report if not selected
    const select = useCallback((index, reportId) => __awaiter(this, void 0, void 0, function* () {
        const item = selectedReportsRef.current[index];
        if (!item || !item.data || item.data.id !== reportId || item.error) {
            return loadReport(index, reportId);
        }
        return item;
    }), [loadReport]);
    // remove report from selection
    const deselect = useCallback((index) => {
        selectedReportsRef.current = Array.from(selectedReportsRef.current);
        // avoid splice to preserve other index values
        selectedReportsRef.current[index] = undefined;
        setSelectedReports(selectedReportsRef.current);
    }, []);
    const clearSelected = useCallback(() => {
        selectedReportsRef.current = [];
        setSelectedReports(selectedReportsRef.current);
    }, []);
    const manager = useMemo(() => {
        return {
            clearList,
            clearSelected,
            deselect,
            load,
            loadAliases,
            select,
            // items may not be set since they are saved and loaded by index
            getReportsList: () => {
                return reportListsRef.current.map(item => item === null || item === void 0 ? void 0 : item.data);
            },
            getSelectedReports: () => {
                return selectedReportsRef.current.map(item => item === null || item === void 0 ? void 0 : item.data);
            }
        };
    }, [clearList, clearSelected, deselect, load, loadAliases, select]);
    return { manager, getReportList, getSelectedReport };
}
//# sourceMappingURL=useMultipleReports.js.map